import { AdminPortal } from './pages/AdminPortal';
import { HomePage } from './pages/HomePage';
import { ProductsPage } from './pages/ProductsPage';

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/admin') return <AdminPortal />;
  if (path === '/products') return <ProductsPage />;
  return <HomePage />;
}
